<template lang="pug">
div
  div(v-if="loader12 || channelLoader")
    Loader 
  .summaryContainer
    .card.tw-my-4
      .tw-flex.tw-justify-between.tw-items-center
        .tw-flex.tw-gap-3
          div(class="2xl:tw-text-base xl:tw-text-sm") 
            .tw-text-sm.tw-ml-1.tw-mb-1(class="tw-text-[#1e1e1e]") Date Range
            date-range-picker.customDateRange(
              v-model="dateRange",
              opens="right",
              :autoApply="true",
              :locale-data="{ format: 'dd mmm yyyy' }",
              @update="formatDates()",
              :ranges="customRanges",
              :show-dropdowns="true"
            )
          .customMultiselectCommon.tw-w-36.tw-mb-2.tw-text-sm(class="2xl:tw-w-48") 
            .tw-text-sm.tw-ml-1.tw-mb-1(class="tw-text-[#1e1e1e]") Channel
            multiselect(
              v-model="selectedChannel",
              :options="channelList",
              placeholder="Select Channel",
              track-by="key",
              label="label",
              :searchable="false",
              :show-labels="false",
              open-direction="bottom",
              :multiple="false",
              :allow-empty="false",
              :close-on-select="true",
              @input="handleChannel(false)"
            )
          .customMultiselectCommon.tw-mb-2.tw-w-44.tw-text-sm(class="2xl:tw-w-52") 
            .tw-text-sm.tw-ml-1.tw-mb-1(class="tw-text-[#1e1e1e]") AD/Campaign Type
            multiselect.tw-capitalize(
              v-model="selectedCampaignTypeData",
              :options="campaignOptions",
              placeholder="Select Campaign Type",
              track-by="label",
              label="label",
              limit="1",
              :searchable="false",
              :show-labels="false",
              open-direction="bottom",
              :multiple="true",
              :allow-empty="false",
              :close-on-select="false"
              @input="handleCampaignSelection"
            )
              template(slot="option", slot-scope="{ option }")
                input(
                  type="checkbox",
                  :value="option",
                  v-model="selectedCampaignTypeData"
                )
                span.option__title.tw-ml-3 {{ option.label }}

          .customMultiselectCommon.tw-w-36.tw-mb-2.tw-text-sm(class="2xl:tw-w-48") 
            
            .tw-text-sm.tw-ml-1.tw-mb-1(class="tw-text-[#1e1e1e]") Campaign Status
            multiselect(
              v-model="activeCampaign",
              :options="campaignStatusList",
              placeholder="Select Status",
              :searchable="false",
              :show-labels="false",
              open-direction="bottom",
              :multiple="true",
              :allow-empty="true",
              :close-on-select="false"
              track-by="value",
              label="value",
              limit="1",
              @input="handleCampaignStatusSelection"
            )
              template(slot="option", slot-scope="{ option }")
                input(
                  type="checkbox",
                  :value="option",
                  v-model="activeCampaign"
                )
                span.option__title.tw-ml-3 {{ option.value }}

          div
            .tw-ml-2.tw-mb-1.tw-font-medium.tw-text-sm(class="tw-text-[#1e1e1e]") Filter By
            #customFilterDropdown
              select.tw-rounded.tw-relative.tw-w-36.tw-text-sm(
                v-model="filterBy",
                class="tw-text-[#44777A] tw-text-[14px] tw-py-[5px] 2xl:tw-w-48 ",
                @click="handleIsFilter"
              )
                option(value="", disabled) Filter By
                option.tw-capitalize(value="performance") Performance Metrics
                option.tw-capitalize(value="campaign") Campaign Name
                option.tw-capitalize(value="campaign_age") Campaign Age

            .tw-relative(v-if="isFilter")
              .tw-shadow-2xl.bg-white.tw-rounded.p-3.tw-absolute.tw-top-full.tw-right-0.tw-mt-2.tw-z-10.border-2(
                v-if="filterBy === 'performance' || filterBy === 'campaign' || filterBy === 'campaign_age'"
              )
                div(v-if="filterBy === 'performance'")
                  #customFilterDropdown.tw-flex.tw-gap-2(
                    v-if="numericFiltersFields && numericFiltersFields.fields"
                  )
                    select.tw-py-1.tw-rounded.tw-text-sm.tw-w-36(
                      v-model="selectedNumericCampaignValue",
                      class="tw-text-[#44777A] tw-text-[14px] 2xl:tw-w-48",
                      @click="handleNumericFilterModal(selectedNumericCampaignValue)"
                    )
                      option.tw-capitalize(
                        v-for="(item, index) in numericFiltersFields?.fields",
                        :key="index",
                        :value="item"
                      ) {{ item }}

                    select.tw-capitalize.tw-h-10.tw-rounded.tw-text-sm.tw-w-36(
                      class="tw-text-[#44777A] tw-text-[14px] 2xl:tw-w-48",
                      v-model="selectedNumericMatricsValue",
                      @click="handleNumericMatricFilterModal(selectedNumericMatricsValue)"
                    )
                      option.tw-capitalize(
                        v-for="(item, index) in numericFiltersFields?.metrics",
                        :key="index",
                        :value="item"
                      ) {{ item }}

                    input.tw-h-9.tw-px-1.tw-mr-3.bg-white.tw-text-sm.tw-rounded.block.tw-w-36.tw-text-sm(
                      v-if="selectedNumericCampaignValue == 'Start Date'",
                      class="tw-text-[#44777A] tw-text-[14px] 2xl:tw-w-48 focus:tw-ring-0 focus:tw-outline-none disabled:tw-opacity-50 focus:tw-border-[#B3B2B9] tw-border-[#B3B2B9] tw-border-[1px] disabled:cursor-not-allowed",
                      v-model="matricsInputValue",
                      type="date",
                      placeholder="Value"
                    ) 
                    input.tw-h-9.tw-px-1.tw-mr-3.tw-bg-white.tw-text-sm.tw-rounded.block.tw-w-36.tw-text-sm(
                      v-else,
                      class="tw-text-[#44777A] tw-text-[14px] 2xl:w-48 focus:tw-ring-0 focus:tw-outline-none disabled:tw-opacity-50 focus:tw-border-[#B3B2B9] tw-border-[#B3B2B9] tw-border-[1px] disabled:tw-cursor-not-allowed",
                      v-model="matricsInputValue",
                      type="number",
                      placeholder="Value"
                    ) 

                  footer.rounded-lg.tw-sticky.tw-bottom-0.tw-w-full.tw-py-4.tw-mb-0.tw-flex.tw-justify-end.tw-px-3
                    button.tw-h-8.text-primary_brand.tw-mr-2.tw-font-medium.tw-rounded.tw-text-md.tw-px-3.tw-text-center.tw-inline-flex.tw-items-center(
                      class="tw-border-[1px] tw-border-[#275659] focus:tw-border-[#275659] focus:tw-outline-none focus:tw-shadow-none"
                      @click="clearFilter"
                    ) 
                      
                      span Cancel
                    button.tw-h-8.text-white.tw-bg-primary_brand.tw-font-medium.tw-rounded.tw-text-md.tw-px-3.tw-text-center.tw-inline-flex.tw-items-center(
                      class="hover:tw-bg-primary_brand-80",
                      @click="postNumericalFilters()"
                    ) 
                      
                      span Add Filter

                div(v-if="filterBy === 'campaign'")
                  #customFilterDropdown.tw-flex.tw-gap-2(
                    v-if="stringFiltersFields && stringFiltersFields.fields"
                  )
                    select.tw-rounded.tw-py-1.tw-w-36.tw-text-sm(
                      v-model="selectedStringCampaignValue",
                      class="tw-text-[#44777A] tw-text-[14px] 2xl:tw-w-48",
                      @click="handleStringFilterModal(selectedStringCampaignValue)"
                    )
                      option.tw-capitalize(
                        v-for="(data, index) in stringFiltersFields?.fields",
                        :key="index",
                        :value="data"
                      ) {{ data }}

                    select.tw-capitalize.tw-h-10.tw-rounded.tw-py-1.tw-text-sm.tw-w-36(
                      v-model="selectedStringMatricsValue",
                      class="tw-text-[#44777A] tw-text-[14px] 2xl:tw-w-48",
                      @click="handleStringMatricsFilterModal(selectedStringMatricsValue)"
                    )
                      option.tw-capitalize(
                        v-for="(data, index) in stringFiltersFields?.metrics",
                        :key="index",
                        :value="data"
                      ) {{ data }}

                    input.tw-h-9.tw-px-1.tw-mr-3.tw-bg-white.tw-rounded.tw-block.tw-text-sm.tw-w-36(
                      class="tw-text-[#44777A] tw-text-[14px] 2xl:tw-w-48 focus:ring-0 focus:tw-outline-none disabled:tw-opacity-50 focus:tw-shadow-none disabled:cursor-not-allowed focus:tw-border-[#B3B2B9] tw-border-[#B3B2B9] tw-border-[1px]",
                      v-model="StringMatricsInputValue",
                      type="text",
                      placeholder="Value"
                    ) 

                  footer.tw-rounded-lg.tw-sticky.tw-bottom-0.tw-flex.tw-justify-end.tw-bg-white.tw-w-full.tw-py-4.tw-mb-0.tw-px-3
                    button.tw-h-8.tw-text-primary_brand.tw-mr-2.tw-font-medium.tw-rounded.tw-text-md.tw-px-3.tw-text-center.tw-inline-flex.tw-items-center(class="tw-border-[1px] tw-border-[#275659] focus:tw-border-[#275659] focus:tw-outline-none focus:tw-shadow-none" @click="clearFilter")   
                      span Cancel
                    button.tw-h-8.text-white.tw-bg-primary_brand.tw-font-medium.tw-rounded.tw-text-md.tw-px-3.tw-text-center.tw-inline-flex.tw-items-center(
                      class="hover:tw-bg-primary_brand-80",
                      @click="handlePostStringFilters()"
                    ) 
                      
                      span Add Filter

                div(v-if="filterBy === 'campaign_age'")
                  #customFilterDropdown.tw-flex.tw-gap-2
                    select.tw-capitalize.tw-h-10.tw-rounded.tw-py-1.tw-text-sm.tw-w-48(
                      v-model="selectedCampaignAgeMetricValue",
                      class="tw-text-[#44777A] tw-text-[14px]"
                    )
                      option.tw-capitalize(value="campaign_age") Campaign Age

                    select.tw-capitalize.tw-h-10.tw-rounded.tw-py-1.tw-text-sm.tw-w-48(
                      v-model="selectedCampaignAgeValue",
                      class="tw-text-[#44777A] tw-text-[14px]"
                    )
                      option.tw-capitalize(
                        v-for="(data, index) in campaignAgeOptions",
                        :key="index",
                        :value="data"
                      ) {{ data }}

                  footer.rounded-lg.tw-sticky.tw-bottom-0.tw-flex.tw-justify-end.tw-bg-white.tw-w-full.tw-py-4.tw-mb-0.tw-px-3
                    button.tw-h-8.tw-text-primary_brand.tw-mr-2.tw-font-medium.tw-rounded.tw-text-md.tw-px-3.tw-text-center.tw-inline-flex.tw-items-center(
                    class="tw-border-[1px] tw-border-[#275659] focus:tw-border-[#275659] focus:tw-outline-none focus:tw-shadow-none"
                      @click="clearFilter"
                    ) 
                      
                      span Cancel
                    button.tw-h-8.text-white.tw-bg-primary_brand.tw-font-medium.tw-rounded.tw-text-md.tw-px-3.tw-text-center.tw-inline-flex.tw-items-center(
                      class="hover:tw-bg-primary_brand-80",
                      @click="handlePostCampaignAgeFilters()"
                    ) 
                      
                      span Add Filter
        .tw-flex.tw-gap-4.tw-mt-2
          button.primarycolor.btn(@click="applyFilters('')") Apply Filters
          button.navigationButton(@click="handleSetAlert") Set Alerts

      .tw-flex.tw-flex-wrap.tw-gap-2.tw-pt-2(
        v-if="storeNumericFilterValue?.length || storeStringFilterValue?.length || storeCampaignAge?.length",
        style="border-top: 1px solid #d4d4d4"
      )
        .tw-flex.tw-flex-wrap.tw-gap-2(v-if="storeNumericFilterValue?.length")
          div(v-for="(item, index) in storeNumericFilterValue", :key="index") 
            
            span#badge-dismiss-default.tw-inline-flex.tw-items-center.tw-py-2.tw-px-3.tw-mb-2.text-sm.tw-text-primary_brand.tw-rounded-md(
              v-for="(data, index) in item",
              :key="index",
              class="tw-bg-[#E7EEEE] tw-font-[500]"
            )
              span.capitalize {{ data.field }}: {{ data.operation }}&nbsp;
              span {{ data.value }}
              button.tw-inline-flex.tw-items-center.p-1.ms-2.tw-text-sm.tw-text-primary_brand.tw-bg-transparent.tw-rounded-sm.tw-font-semibold(
                type="button",
                data-dismiss-target="#badge-dismiss-default",
                aria-label="Remove",
                @click="RemoveFilterBadgeValue(data)"
              )
                svg.tw-w-2.tw-h-2(
                  aria-hidden="true",
                  xmlns="http://www.w3.org/2000/svg",
                  fill="none",
                  viewBox="0 0 14 14"
                )
                  path(
                    stroke="currentColor",
                    stroke-linecap="round",
                    stroke-linejoin="round",
                    stroke-width="2",
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  )
                span.sr-only Remove badge

        .tw-flex.tw-flex-wrap.tw-gap-2(v-if="storeStringFilterValue?.length")
          div(v-for="(item, index) in storeStringFilterValue", :key="index")
            span#badge-dismiss-default.tw-inline-flex.tw-items-center.tw-py-2.tw-px-3.tw-mb-2.tw-text-sm.tw-text-primary_brand.tw-font-medium.tw-rounded-md(
              v-for="(data, index) in item",
              :key="index",
              class="tw-bg-[#E7EEEE]"
            )
              span.capitalize {{ data.field }}: {{ data.operation }}&nbsp;
              span {{ data.value }}
              button.tw-inline-flex.tw-items-center.tw-p-1.ms-2.tw-text-sm.tw-text-primary_brand.tw-bg-transparent.tw-rounded-sm(
                type="button",
                data-dismiss-target="#badge-dismiss-default",
                aria-label="Remove",
                @click="RemoveFilterBadgeValue(data)"
              )
                svg.tw-w-2.tw-h-2(
                  aria-hidden="true",
                  xmlns="http://www.w3.org/2000/svg",
                  fill="none",
                  viewBox="0 0 14 14"
                )
                  path(
                    stroke="currentColor",
                    stroke-linecap="round",
                    stroke-linejoin="round",
                    stroke-width="2",
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  )
                span.sr-only Remove badge

        .tw-flex.tw-flex-wrap.tw-gap-2(v-if="storeCampaignAge?.length")
          div(v-for="(item, index) in storeCampaignAge", :key="index")
            span#badge-dismiss-default.tw-inline-flex.tw-items-center.tw-capitalize.tw-py-2.tw-px-3.tw-mb-2.tw-text-sm.tw-text-primary_brand.tw-font-medium.tw-rounded-md(
              v-for="(data, index) in item",
              :key="index",
              class="tw-bg-[#E7EEEE]"
            )
              | {{ data.field.replaceAll("_", " ") }}: {{ data.value }}
              button.inline-flex.items-center.p-1.ms-2.text-sm.text-primary_brand.bg-transparent.rounded-sm(
                type="button",
                data-dismiss-target="#badge-dismiss-default",
                aria-label="Remove",
                @click="RemoveFilterBadgeValue(data)"
              )
                svg.w-2.h-2(
                  aria-hidden="true",
                  xmlns="http://www.w3.org/2000/svg",
                  fill="none",
                  viewBox="0 0 14 14"
                )
                  path(
                    stroke="currentColor",
                    stroke-linecap="round",
                    stroke-linejoin="round",
                    stroke-width="2",
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  )
                span.sr-only Remove badge
        .tw-flex.tw-items-center.tw-gap-2(
          v-if="storeNumericFilterValue.length || storeStringFilterValue.length || storeCampaignAge.length"
        )
          span.tw-mb-2.tw-ml-2.tw-cursor-pointer(
            @click="RemoveAllFilterBadgeValue",
            class="tw-text-[#8C0000] tw-text-[14px]"
          ) Remove all
    .card.tw-mb-4
      .tw-flex.tw-justify-between.tw-items-center(
        class="tw-border-b-[1px] tw-border-[#d4d4d4]"
      )
        .tw-pb-2.tw-mb-2.tw-text-primary_brand.tw-font-semibold(class="tw-text-[16px]") Campaign Level Data
        .tw-flex.tw-gap-3(v-if="viewCampaignData?.data?.length")
          div
            span Budget Usage (%) :
          div
            span.tw-ml-1.tw-mr-2(@click="filterBudgetUsage('negative')") 
              
              i.tw-mr-1.fa.fa-square.tw-cursor-pointer(class="tw-text-[#FFBEB5]")
              span.tw-mr-2 > 90%
            span(@click="filterBudgetUsage('neutral')") 
             
              i.fa.fa-square.tw-cursor-pointer(class="tw-text-[#B2BDFF]") 
              span.tw-ml-2 75% - 90%
      div(v-if="viewCampaignData?.data?.length")
        .tw-flex.tw-items-center.tw-gap-3.tw-mb-2.tw-pb-2(
          style="border-bottom: 1px solid #d4d4d4"
        )
          .tw-my-3.tw-rounded(class="tw-bg-[#0655591A] tw-w-[100%]")
            .tw-my-1.tw-px-2.tw-pb-4.tw-pt-2.tw-mx-1.tw-flex.tw-flex-wrap
              div(v-for="metric of selectedHeaders", :key="metric")
                .tw-mt-2.tw-inline-flex.tw-items-center.tw-px-2.tw-rounded.tw-text-sm.tw-font-medium.tw-text-center.tw-text-black.bg-white.tw-mr-2(
                  class="tw-py-2.5"
                )
                  span {{ metric }}
                  span.tw-inline-block.tw-items-center.tw-ml-2.tw-cursor-pointer(
                    @click="removeSelectedMetric(idx, metric)"
                  )
                    img.tw-w-3(src="Icons_SVG/cross.svg")

              div(ref="metricDropdownRef", v-if="!allHeadersSelected")
                .tw-cursor-pointer.tw-mt-2.tw-inline-flex.tw-items-center.tw-px-3.tw-rounded.tw-text-sm.tw-font-medium.tw-text-center.tw-text-primary_brand.tw-mr-2(
                  @click="toggleAdMetricDropdown",
                  class="tw-py-2.5 tw-bg-[#fff]"
                )
                  span.tw-inline-block.tw-items-center.tw-mr-1.tw-cursor-pointer
                    i.fa.fa-plus 
                  span Add Metric
                .tw-mt-2.tw-overflow-auto.tw-scroll-smooth.tw-absolute.tw-border-primary_brand.tw-rounded(
                  v-if="isMetricDropdown",
                  class="tw-z-[99] tw-h-[200px] tw-bg-[#fff] tw-border-[1px]"
                ) 
                 
                  ul.tw-w-48.tw-text-sm.tw-font-medium.tw-text-gray-900.bg-white.tw-p-2.tw-pb-0.tw-rounded-lg(
                    class="tw-z-[99]"
                  )
                    li.tw-w-full.tw-flex.tw-items-center.tw-ps-3.tw-rounded-t-lg
                      input.tw-cursor-pointer.tw-w-4.tw-h-4.tw-text-blue-600.tw-bg-gray-100.tw-border-gray-300(
                        type="checkbox",
                        id="select-all",
                        :checked="allHeadersSelected",
                        @change="toggleSelectAll",
                        class="tw-rounded-[6px] focus:ring-blue-500"
                      )
                      label.tw-cursor-pointer.tw-w-full.tw-ms-3.tw-text-sm.tw-font-medium.tw-text-gray-900.tw-mt-2(for="select-all") All
                    li.tw-w-full.tw-flex.tw-items-center.tw-ps-3.tw-rounded-t-lg(
                      v-for="header of headersList",
                      :key="header"
                    )
                      
                      input.tw-cursor-pointer.tw-w-4.tw-h-4.tw-text-blue-600.tw-bg-gray-100.tw-border-gray-300(
                        type="checkbox",
                        :value="header",
                        :name="header",
                        v-model="selectedHeaders",
                        :id="header",
                        class="tw-rounded-[6px] focus:ring-blue-500"
                      ) 
                      label.tw-cursor-pointer.tw-w-full.tw-ms-3.tw-text-sm.tw-font-medium.tw-text-gray-900.tw-mt-2(
                        :for="header"
                      ) {{ header }}

        table#campaignTable-tbl.tw-w-full(v-if="viewCampaignData?.data?.length")
          thead.tw-w-full
            tr
              th(
                v-if="i !== 'flag'",
                v-for="(data,i) of viewCampaignData?.data[0]",
                :key="'cam' + i"
              ) 
                
                .tw-text-nowrap.tw-mr-4
                  span {{ i }}
                  span(v-if="data.prefix") ({{ data.prefix }})
                  span(v-if="data.suffix") ({{ data.suffix }})
          tbody.tw-w-full 
           
            tr(
              v-for="(data,i) of viewCampaignData?.data",
              :key="'camp' + i",
              v-if="data['Campaign Name']['value'] != 'Total'"
            )
              td(
                v-for="(head,idx) of viewCampaignData?.data[0]",
                v-if="idx !== 'flag'",
                :style="{ backgroundColor: rowColor(data, idx) }"
              ) 
                
                span.tw-cursor-pointer(
                  v-if="idx == 'Campaign Name'",
                  @click="goToAnalysis(data[idx].value)"
                ) 
                 
                  span.tw-underline(class="tw-font-[500]") {{ formatNumber(data[`${idx}`].value) }}
                span(v-else) 
                 
                  span {{ formatNumber(data[`${idx}`].value) }}
          tfoot
            tr(
              v-for="(data,i) of viewCampaignData?.data",
              v-if="data['Campaign Name']['value'] == 'Total'"
            )
              th(
                v-for="(head,i) of viewCampaignData?.data[0]",
                v-if="i != 'flag'"
              ) {{ formatNumber(data[`${i}`].value) }}
      .onLoadingData.tw-mt-4(v-else-if="isViewCampaignDataLoader") Loading...
      .tw-text-danger.tw-flex.tw-justify-center.tw-border.tw-border-danger.tw-rounded.tw-mt-4.tw-p-2.noData(
        v-else
      ) No Data Available
  div
    .tw-grid.tw-grid-cols-2.tw-mx-4.tw-gap-4(
      class="tw-xs:grid-cols-1 tw-sm:grid-cols-2"
    )
      .card(v-if="campaignGraphData", style="height: 870px")
        .tw-text-primary_brand.tw-flex.tw-items-center.tw-mb-2.tw-pb-2.tw-font-semibold.tw-tracking-wide(
          class="tw-text-[16px]",
          style="border-bottom: 1px solid #d4d4d4"
        ) Set Target ACOS
        .tw-mb-5.tw-flex.tw-justify-between.tw-pb-2(
          style="border-bottom: 1px solid #d4d4d4"
        )
          input#small-input.tw-bg-white.tw-border-solid.tw-border.tw-border-primary_brand-80.tw-block.tw-rounded-md.tw-h-9.tw-px-3(
            type="number",
            class="tw-w-1/3 tw-text-[14px] focus:tw-ring-0 focus:tw-border-primary_brand focus:tw-outline-none",
            placeholder="Set Target ACOS",
            v-model="targetACOS"
          )
          .tw-flex.tw-items-center
            button.primarycolor.btn.tw-mr-2(@click="postTargetACOSData(false)") 
             
              span Apply
            button.tw-text-primary_brand.tw-font-bold.tw-px-5.tw-text-center.tw-inline-flex.tw-items-center(
              class="hover:tw-bg-primary_brand tw-rounded-[6px] hover:tw-text-[#fff] tw-py-[5px] tw-text-[16px]",
              style="border: 1px solid #065559",
              @click="postTargetACOSData(true)"
            ) 
              
              span Reset
        .tw-flex.tw-justify-between.tw-mb-8
          .tw-flex.tw-gap-4
            div
              div(class="xl:tw-mt-[-4px] 2xl:tw-mt-[-1.5px]", v-if="viewCampaignData")
                .tw-text-primary_brand.tw-font-medium.amsTooltip(
                  class="2xl:tw-text-sm xl:tw-text-xs"
                ) Target ACOS
                  |
                  span.amsTooltiptext
                    .tw-text-sm {{ viewCampaignData?.target_acos_meta?.comment }}
                    div(
                      v-if="viewCampaignData?.target_acos_meta?.last_modified_by"
                    ) Last modified by: {{ viewCampaignData?.target_acos_meta?.last_modified_by }}
                    div(
                      v-if="viewCampaignData?.target_acos_meta?.last_modified_time"
                    ) Last modified time: {{ viewCampaignData?.target_acos_meta?.last_modified_time }}
                div(class="2xl:tw-text-lg xl:tw-text-xs") {{ formatNumber(campaignGraphData?.targetACOS) }}%
            div
              .tw-text-primary_brand.tw-text-base.tw-font-medium(
                class="2xl:tw-text-sm xl:tw-text-xs"
              ) Average ACOS
              .tw-text-lg(class="2xl:tw-text-lg xl:tw-text-xs") {{ formatNumber(campaignGraphData?.avgACOS) }}%
            div(class="2xl:tw-text-sm xl:tw-text-xs")
              .tw-text-primary_brand.tw-text-base.tw-font-medium(
                class="2xl:tw-text-sm xl:tw-text-xs"
              ) Average Sales
              .tw-text-lg(class="2xl:tw-text-lg xl:tw-text-xs") &#8377; {{ formatNumber(campaignGraphData?.xAxis?.mean) }}
            div
              .tw-text-primary_brand.tw-text-base.tw-font-medium(
                class="2xl:tw-text-sm xl:tw-text-xs"
              ) Average Spends
              .tw-text-lg(class="2xl:tw-text-lg xl:tw-text-xs") &#8377; {{ formatNumber(campaignGraphData?.zAxis?.mean) }}

        .w-full.tw-relative
          scatterGraph(
            :yAxisMean="campaignGraphData?.targetACOS",
            :xAxisMax="maxSales",
            :seriesData="campaignGraphData?.seriesData",
            :xAxis="campaignGraphData?.xAxis",
            :yAxis="campaignGraphData?.yAxis",
            :zAxis="campaignGraphData?.zAxis",
            :name="campaignGraphData?.seriesData?.[0]?.name",
            :xAxisName="campaignGraphData?.xAxisName",
            :yAxisName="campaignGraphData?.yAxisName",
            :zAxisName="campaignGraphData?.zAxisName",
            @filter-table="filterCampTable"
          )
          .tw-flex.tw-gap-3.tw-justify-center.tw-mb-3(
            v-if="campaignAgeMetaData"
          )
            div
              i.fa.fa-circle(class="tw-text-[#1ACF85] tw-text-[14px]")
              .tw-ml-1.amsTooltip(class="tw-text-[14px]") New
                span.amsTooltiptext
                  .tw-text-sm {{ campaignAgeMetaData?.New }}
            div
              i.fa.fa-circle(class="tw-text-[#FFAB00] tw-text-[14px]")
              .tw-ml-1.amsTooltip(class="tw-text-[14px]") Intermediate
                span.amsTooltiptext
                  .tw-text-sm {{ campaignAgeMetaData?.Intermediate }}
            div
              i.fa.fa-circle(class="tw-text-[#00A1C9] tw-text-[14px]")
              .tw-ml-1.amsTooltip(class="tw-text-[14px]") Old
                span.amsTooltiptext
                  .tw-text-sm {{ campaignAgeMetaData?.Old }}
      .card
        .tw-text-primary_brand.tw-flex.tw-items-center.tw-mb-2.tw-pb-2.tw-mb-3.tw-font-semibold.tw-tracking-wide(
          class="tw-text-[16px]",
          style="border-bottom: 1px solid #d4d4d4"
        ) Top Insights
        .thin-scrollerBar.tw-pr-1.tw-pt-1.tw-overflow-auto(class="tw-h-[790px]")
          div(v-if="isAmazonInsight") 
            
            .onLoadingData.tw-my-4.tw-mx-1 Fetching Data From Amazon Insight...

          .inSightsContainer.tw-flex.tw-mb-3(
            v-else,
            v-for="(insight, index) in amazonInsight",
            :key="index"
          )
            .tw-col-1.tw-flex.tw-justify-center.tw-items-center.tw-flex-col.tw-px-4(
              class="tw-xl:text-[16px] tw-text-[14px]"
            )
              p.tw-text-nowrap(class="tw-text-[#00555A]") Updated At:
              p.tw-font-bold(class="tw-text-[#5e5e5e]") {{ insight.date }}
            .tw-col-11.tw-p-2.tw-overflow-auto
              p.tw-mb-2.tw-font-bold.tw-tracking-wide(
                class="tw-xl:text-[16px] tw-text-[14px]"
              ) {{ insight.heading }}
              p(class="tw-xl:text-[14px] tw-text-[12px]", v-html="insight.description")

          div(v-if="isCampaignInsight") 
           
            .onLoadingData.tw-my-4.tw-mx-1 Fetching Data From Campaigns Insight...

          .inSightsContainer.tw-flex.tw-mb-3(
            v-else,
            v-for="(insight, index) in campaignInsight",
            :key="index"
          )
            .tw-col-1.tw-flex.tw-justify-center.tw-items-center.tw-flex-col.tw-px-4(
              class="tw-xl:text-[16px] tw-text-[14px]"
            )
              p.tw-text-nowrap(class="tw-text-[#00555A]") Updated At:
              p.tw-font-bold(class="tw-text-[#5e5e5e]") {{ insight.date }}
            .tw-col-11.tw-p-2.tw-overflow-auto
              p.tw-mb-2.tw-font-bold.tw-tracking-wide(
                class="tw-xl:text-[16px] tw-text-[14px]"
              ) {{ insight.heading }}
              p(class="tw-xl:text-[14px] tw-text-[12px]", v-html="insight.description")

    .card.tw-mx-4
      .tw-text-primary_brand.tw-flex.tw-items-center.tw-pb-2.tw-font-semibold.tw-tracking-wide(
        class="tw-text-[16px]",
        style="border-bottom: 1px solid #d4d4d4"
      ) High ACOS Campaigns
      .summaryContainer.tw-mt-3(v-if="insightsData?.length")
        table#insights-table.tw-w-full
         
          thead
            tr
              th(v-for="head of insightsHeader", :key="head") {{ head }}
          tbody
            tr(
              v-for="(row,idx) of insightsData",
              :key="idx",
              v-if="row[insightsHeader[0]].value != 'Total'"
            )
              td.cursor-pointer(v-for="head of insightsHeader", :key="head") 
                
                span {{ row[`${head}`].prefix }}
                span {{ formatNumber(row[`${head}`].value) }}
                span {{ row[`${head}`].suffix }}
          tfoot
            tr(
              v-for="(data,i) of insightsData",
              v-if="data[insightsHeader[0]].value == 'Total'"
            ) 
              
              th(v-for="(head,i) of insightsHeader") {{ data[`${head}`]?.prefix }} {{ formatNumber(data[`${head}`].value) }} {{ data[`${head}`].suffix }}

      .onLoadingData.tw-mt-4(
        v-else-if="isInsightDataLoader && !insightsData?.length"
      ) Loading...
      .tw-text-danger.tw-flex.tw-justify-center.tw-border.tw-border-danger.tw-rounded.tw-mt-4.tw-p-2.noData(
        v-else
      ) No Data Available
</template>
<script>
import moment from "moment";
import scatterGraph from "../../commonCharts/ScatterGraph.vue";
import Multiselect from "vue-multiselect";
import Loader from "../../Components/Loader.vue";

export default {
  name: "AMS",
  components: {
    Loader,
    scatterGraph,
    Multiselect,
  },
  data() {
    return {
      dataLoader: false,
      campLoader: false,
      loader12: false,
      isFilter: false,
      channelLoader: false,
      filterBy: "",
      selectedNumericCampaignValue: "ACOS",
      numericFiltersFields: [],
      selectedNumericMatricsValue: "greater than",
      matricsInputValue: "",
      selectedStringCampaignValue: "Campaign Name",
      stringFiltersFields: [],
      selectedStringMatricsValue: "contains",
      StringMatricsInputValue: "",
      storeNumericFilterValue: [],
      storeStringFilterValue: [],
      selectedCampaignAgeMetricValue: "campaign_age",
      selectedCampaignAgeValue: "New",
      storeCampaignAge: [],
      activeCampaign: [],
      dateRange: {
        startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      modalDateRange: {
        startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      postCampaign: [],
      rulesTableHeader: [],
      rulesTableData: [],
      campaignTableHeader: [],
      campaignTableData: [],
      rulesData: [],
      campaignRules: [],
      ruleName: [],
      rulesOption: [],
      ruleId: [],
      ruleHeading: [],
      rule_id: "",
      campaign: [],
      campaignType: [],
      campType: "",
      campModal: undefined,
      movingAvgModal: undefined,
      campRuleId: "",
      emailError: false,
      isAms: "ams",
      date: "1",
      addEmail: [],
      selectedChannel: [],
      channelList: [],
      selectedChannelKey: "",
      postCamp: [],
      tempEmail: "",
      dropdownOptions2: [
        "Greater Than",
        "Greater Equal",
        "Equal",
        "Less Equal",
        "Less Than",
      ],
      intervalOptions: ["Daily", "Weekly"],
      LastDate: [
        2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
        22, 23, 24, 25, 26, 27, 28, 29, 30,
      ],
      LastDay: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      dataLoader1: false,
      viewCampaignData: "",
      isViewCampaignDataLoader: false,
      tableRawData: [],
      selectedCampaignTypeData: [],
      previousSelection: [],
      previousStatusSelection: [],
      campaignOptions: [],
      campaignGraphData: "",
      campaignAgeMetaData: "",
      scatterChartOption: ["Sales", "Spends"],
      selectedScatterChart: "Sales",
      headersList: [],
      selectedHeaders: [],
      insightsHeader: [],
      insightsData: [],
      isInsightDataLoader: false,
      customRanges: [],
      categoryWiseTableData: "",
      MovingAvgGraphData: [],
      selectedMovAvgData: "Daily",
      modalCampaingName: "",
      graphDropdown: "",
      selectedGraphOptions: "ACOS",
      moviginAvgData: "",
      viewUpdatedAMSRefreshData: "",
      intervalID: null,
      targetACOS: "",
      selectedCampaignAge: [],
      campaignAgeOptions: ["New", "Intermediate", "Old"],
      quadrantData: [],
      quadrantHeader: [],
      filteredQuadrantData: [],
      quadrantModal: "",
      quadrantModalTitle: "",
      maxSales: "",
      runTimes: [],
      campaignStatusList: [],
      selectedCampaign: "",
      isColumns: true,
      amazonInsight: [],
      campaignInsight: [],
      isAmazonInsight: false,
      isCampaignInsight: false,
      isMetricDropdown: false,
    };
  },
  created() {
    const today = new Date();
    const yesterday = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 1
    );
    const monthStartDate = new Date(
      today.getFullYear(),
      today.getMonth() - 1,
      today.getDate() + 0
    );
    const thisMonthStartDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      1
    );
    const thisMonthEndDate = new Date();
    const lastMonthStartDate = new Date(
      today.getFullYear(),
      today.getMonth() - 1,
      1
    );
    const lastMonthEndDate = new Date(today.getFullYear(), today.getMonth(), 0);
    const thisYearStartDate = new Date(today.getFullYear(), 0, 1);
    const thisYearEndDate = new Date(today.getFullYear(), 11, 31);
    const lastYearStartDate = new Date(today.getFullYear() - 1, 0, 1);
    const lastYearEndDate = new Date(today.getFullYear() - 1, 11, 31);
    const quarterStartMonth = Math.floor(today.getMonth() / 3) * 3;
    const quarterStartDate = new Date(
      today.getFullYear(),
      quarterStartMonth,
      1
    );

    // Calculate the first day of the current week (Sunday)
    const firstDayOfCurrentWeek = new Date(today);
    firstDayOfCurrentWeek.setDate(today.getDate() - today.getDay());

    // Calculate the last day of the previous week (Saturday)
    const lastDayOfLastWeek = new Date(firstDayOfCurrentWeek);
    lastDayOfLastWeek.setDate(firstDayOfCurrentWeek.getDate() - 1);

    // Calculate the first day of last week (Sunday)
    const firstDayOfLastWeek = new Date(lastDayOfLastWeek);
    firstDayOfLastWeek.setDate(lastDayOfLastWeek.getDate() - 6);

    this.customRanges = {
      Today: [today, today],
      Yesterday: [yesterday, yesterday],
      Month: [monthStartDate, thisMonthEndDate],
      "Last Week": [firstDayOfLastWeek, lastDayOfLastWeek],
      "Last month": [lastMonthStartDate, lastMonthEndDate],
      "Last Year": [lastYearStartDate, lastYearEndDate],
      MTD: [thisMonthStartDate, today],
      QTD: [quarterStartDate, today],
      YTD: [thisYearStartDate, today],
    };
  },
  computed: {
    amsSelectedDateRange() {
      return this.$store.state.filter.amsSelectedDateRange;
    },
    allHeadersSelected() {
      return (
        this.headersList.length > 0 &&
        this.headersList.every((header) =>
          this.selectedHeaders.includes(header)
        )
      );
    },
  },
  mounted() {
    if (localStorage.campStatus) localStorage.removeItem("campStatus");
    if (localStorage.selectedCampaign)
      localStorage.removeItem("selectedCampaign");
    if (localStorage.dateRange) localStorage.removeItem("dateRange");
    document.addEventListener("click", this.handleClickOutside);
    this.getChannelList();
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    dataAPIS() {
      if (!this.selectedChannelKey) return;

      this.getHeadersList(true);
      if (this.selectedChannelKey == "amazon") {
        this.getUpdatedAMSRefreshData();
        this.getInsightData();
        this.getCampaginsInsight();
      }
      this.checkStatus();
    },
    toggleSelectAll(event) {
      if (event.target.checked) {
        this.selectedHeaders = [...this.headersList];
      } else {
        this.selectedHeaders = [];
      }
    },
    handleClickOutside(event) {
      const dropdown = this.$refs.metricDropdownRef;
      if (dropdown && !dropdown.contains(event.target)) {
        this.isMetricDropdown = false;
      }
    },
    handleChannel(isMounted) {
      this.selectedCampaignTypeData = [];
      this.getHeadersList(isMounted);
      this.$nextTick(() => {
        this.processTable("#insights-table", 1);
      });
    },
    handleCampaignSelection(selected) {
      const otherOptions = this.campaignOptions.filter(
        (opt) => opt.label !== "All"
      );

      const isAllCurrentlySelected = selected.some(
        (opt) => opt.label === "All"
      );
      const wasAllPreviouslySelected = this.previousSelection.some(
        (opt) => opt.label === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedCampaignTypeData = [...this.campaignOptions];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedCampaignTypeData = [];
      } else {
        const selectedWithoutAll = selected.filter(
          (opt) => opt.label !== "All"
        );
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedCampaignTypeData = [...this.campaignOptions];
        } else {
          this.selectedCampaignTypeData = [...selectedWithoutAll];
        }
      }
      this.previousSelection = [...this.selectedCampaignTypeData];
    },
    handleCampaignStatusSelection(selected) {
      const otherOptions = this.campaignStatusList.filter(
        (opt) => opt.key !== "All"
      );

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousStatusSelection.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.activeCampaign = [...this.campaignStatusList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.activeCampaign = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.activeCampaign = [...this.campaignStatusList];
        } else {
          this.activeCampaign = [...selectedWithoutAll];
        }
      }
      this.previousStatusSelection = [...this.activeCampaign];
    },
    getHeadersList(isMounted = true) {
      this.channelLoader = true;
      this.selectedCampaignTypeData = [];
      this.activeCampaign = [];

      const url =
        "/api/v2/slate/headers_filters?channel=" + this.selectedChannel.key;
      this.$http
        .get(url)
        .then((res) => {
          this.campaignOptions = res.data?.data?.data?.campaignOptions;
          this.selectedCampaignTypeData.push(this.campaignOptions[0]);
          this.campaignOptions.unshift({ key: "All", label: "All" });
          this.campaignStatusList = res.data?.data?.data?.campaign_status;
          this.activeCampaign.push(this.campaignStatusList[1]);
          this.numericFiltersFields = res.data?.data?.data?.numerical_filters;
          this.stringFiltersFields = res.data?.data?.data?.string_filters;
          this.headersList = res.data?.data?.data?.campaign_header.filter(
            (item) => item != "flag"
          );
          this.selectedHeaders = this.headersList;

          if (isMounted) {
            this.getCampaignTableData("");
          }
          this.channelLoader = false;
        })
        .catch((err) => {
          console.error(err);
          this.channelLoader = false;
        });
    },

    removeSelectedMetric(idx, metric) {
      this.selectedHeaders = this.selectedHeaders.filter(
        (data) => data != metric
      );
    },
    applyFilters() {
      if ($.fn.dataTable.isDataTable("#insights-table")) {
        $("#insights-table").DataTable().clear().destroy();
      }
      if ($.fn.dataTable.isDataTable("#campaignTable-tbl")) {
        $("#campaignTable-tbl").DataTable().clear().destroy();
      }
      this.selectedChannelKey = this.selectedChannel.key;
      // this.isFilter = false;
      // this.isColumns = false;
      this.getCampaignTableData("");
      // if (this.selectedChannelKey == "amazon") {
        this.getUpdatedAMSRefreshData();
        this.getInsightData();
        this.getCampaginsInsight();
      // }
      localStorage.setItem("dateRange", JSON.stringify(this.dateRange));
    },
    toggleAdMetricDropdown() {
      if (this.isMetricDropdown) {
        this.isMetricDropdown = false;
      } else {
        this.isMetricDropdown = true;
      }
    },
    handleBack() {
      this.selectedCampaign = "";
      $("#campaignTable-tbl").DataTable().column(0).search("").draw();
    },
    handleSetAlert() {
      this.$router.push("/alert");
    },
    validEmail(email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    formateDateRange(timestamp) {
      return moment(timestamp).format("lll");
    },

    updateDateRange() {
      this.radioSelcted = this.selectedLastDate;
    },
    checkStatus() {
      // this.intervalID = setInterval(this.getUpdatedAMSRefreshData, 9000);
    },
    rowColor(rowData, idx) {
      if (idx != "Budget Usage") {
        return false;
      }

      if (rowData["Budget Usage"].value > 90) {
        return "#FFBEB5";
      } else if (
        rowData["Budget Usage"].value < 90 &&
        rowData["Budget Usage"].value > 75
      ) {
        return "#B2BDFF";
      } else {
        return "transparent";
      }
    },
    goToAnalysis(campaignName) {
      // this.$router.push("ams-analytics");
      // localStorage.setItem('dateRange', JSON.stringify(this.dateRange));
      localStorage.setItem("selectedCampaign", campaignName);
      localStorage.setItem(
        "campStatus",
        Array.isArray(this.activeCampaign)
          ? this.activeCampaign.map((item) => item.key)
          : []
      );
    },
    postTargetACOSData(status) {
      this.dataLoader1 = true;
      let url = "/api/v2/slate/targetACOS";
      let payload = {};
      if (status) {
        this.targetACOS = "";
        payload = {
          channel: this.selectedChannel.key,
          reset: status,
        };
      } else {
        if (!this.targetACOS) {
          this.dataLoader1 = false;
          this.$bvToast.toast("Please enter target ACOS", {
            variant: "danger",
            position: "bottom-center",
            timeout: 3000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false,
          });
          return false;
        }
        payload = {
          channel: this.selectedChannel.key,
          target_acos: this.targetACOS,
          reset: status,
        };
      }
      this.$http
        .post(url, payload)
        .then((res) => {
          this.targetACOS = "";
          this.getCampaignTableData("");
          this.dataLoader1 = false;
        })
        .catch((err) => {
          console.log(err);

          this.dataLoader1 = false;
        });
    },
    movingAvg(data) {
      this.modalDateRange.startDate = moment(this.dateRange.startDate).format(
        "YYYY-MM-DD"
      );
      this.modalDateRange.endDate = moment(this.dateRange.endDate).format(
        "YYYY-MM-DD"
      );
      this.modalCampaingName = data["Campaign Name"].value;
      this.movingAverageData();
      // this.movingAvgModal.show();
    },

    formatNumber(num) {
      if (isNaN(num)) return num;
      let num1 = Number(num).toFixed(2);
      let num2 = Number(num1).toLocaleString();
      return num2;
    },
    formatDateRange() {
      this.dateRange.startDate = moment(this.dateRange.startDate).format(
        "YYYY-MM-DD"
      );
      this.dateRange.endDate = moment(this.dateRange.endDate).format(
        "YYYY-MM-DD"
      );
      this.modalDateRange.startDate = moment(
        this.modalDateRange.startDate
      ).format("YYYY-MM-DD");
      this.modalDateRange.endDate = moment(this.modalDateRange.endDate).format(
        "YYYY-MM-DD"
      );
    },
    formatDates() {
      this.formatDateRange();
    },
    RemoveBadgeValue(item) {
      this.selectedHeaders = this.selectedHeaders.filter(
        (header) => header !== item
      );
    },
    RemoveAllBadgeValue() {
      this.selectedHeaders = [];
    },
    filterCampTable(campName) {
      this.selectedCampaign = "";
      this.selectedCampaign = campName;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      $("#campaignTable-tbl")
        .DataTable()
        .column(0)
        .search(campName, false, false)
        .draw();
    },
    getUpdatedAMSRefreshData() {
      let intervalTempId = this.intervalID;
      this.viewUpdatedAMSRefreshData = "";
      let url =
        "/api/v2/slate/GetRefreshAmsDataStatus?channel=" +
        this.selectedChannel.key;
      this.$http
        .get(url)
        .then((res) => {
          this.viewUpdatedAMSRefreshData = res.data.data;
          // if (
          //   this.viewUpdatedAMSRefreshData.refresh_status === "failed" ||
          //   this.viewUpdatedAMSRefreshData.refresh_status === "completed"
          // ) {
          //   clearInterval(intervalTempId);
          // }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getStatusColor(status) {
      if (status == "completed") {
        return "green";
      } else if (status == "running") {
        return "orange";
      } else if (status == "failed") {
        return "red";
      }
    },
    refrencePageData() {
      this.dataLoader1 = true;
      let url = "/api/v2/amazon/RefreshAmsData";
      this.$http
        .post(url, {})
        .then((res) => {
          this.dataLoader1 = false;
          this.getUpdatedAMSRefreshData();
          this.checkStatus();
        })
        .catch((err) => {
          console.log(err);

          this.dataLoader1 = false;
        });
    },
    filterQuadrantData(quadrant) {
      this.filteredQuadrantData = this.quadrantData.filter(
        (row) => Number(row.Quadrant) === quadrant
      );
      this.quadrantModalTitle = `Campaigns for Quadrant - ${Number(quadrant)}`;
      // this.quadrantModal.show();
      this.$nextTick(() => {
        this.processTable("#quadrant_table", 3);
      });
    },
    hideQuadrantModal() {
      // this.quadrantModal.hide();
      $("#quadrant_table").DataTable().destroy();
      this.filteredQuadrantData = [];
      this.quadrantModalTitle = "";
    },
    getChannelList() {
      const url = "/api/slate/platformstatus";
      this.$http
        .get(url)
        .then((res) => {
          this.channelList = res.data.data.channelslist;
          this.selectedChannel = this.channelList[0];
          this.selectedChannelKey = this.selectedChannel?.key;
          this.dataAPIS();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getCampaignTableData(sentimentFilter) {
      if ($.fn.dataTable.isDataTable("#insights-table")) {
        $("#insights-table").DataTable().clear().destroy();
      }
      if ($.fn.dataTable.isDataTable("#campaignTable-tbl")) {
        $("#campaignTable-tbl").DataTable().clear().destroy();
      }
      if (!this.selectedCampaignTypeData.length) {
        this.$bvToast.toast("Please Select the Campaign Type.", {
          variant: "danger",
          toaster: "b-toaster-top-center",
          autoHideDelay: 3000,
        });
        return false;
      }

      if (!this.activeCampaign.length) {
        this.$bvToast.toast("Please Select the Campaign Status.", {
          variant: "danger",
          toaster: "b-toaster-top-center",
          autoHideDelay: 3000,
        });
        return false;
      }
      this.loader12 = true;
      this.isViewCampaignDataLoader = true;
      this.isInsightDataLoader = true;
      this.viewCampaignData = "";
      this.categoryWiseTableData = "";
      this.insightsHeader = [];
      this.insightsData = [];
      this.tableRawData = [];
      this.campLoader = true;
      let url = "/api/v2/slate/campaigns_data";
      let adType = [];
      if (
        this.selectedHeaders &&
        this.selectedHeaders?.length &&
        !this.selectedHeaders.includes("Campaign Name")
      ) {
        this.selectedHeaders?.unshift("Campaign Name");
      }

      const header = this.selectedHeaders.filter((item) => item.key !== "All");

      let payload = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        fields: header,
        channel: this.selectedChannel.key,
        campaigns_age_filter_list: this.storeCampaignAge?.flat(),
        numerical_filter_list: this.storeNumericFilterValue?.flat(),
        string_filter_list: this.storeStringFilterValue?.flat(),
        // camp_state: "All",
        camp_state: Array.isArray(this.activeCampaign)
          ? this.activeCampaign
              .filter((item) => item.key !== "All")
              .map((item) => item.key)
          : [],
      };
      if (sentimentFilter) payload.flag_filter.push(sentimentFilter);

      if (!this.selectedCampaignTypeData.length) {
        adType = [];
      } else {
        this.selectedCampaignTypeData
          .filter((adType) => adType.key != "All")
          ?.forEach((element) => {
            adType.push(element.key);
          });
      }
      payload = { ...payload, ad_type: adType };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.viewCampaignData = res.data?.data;
          this.tableRawData = res.data?.data?.data;
          this.campaignAgeMetaData = res.data?.data?.campaign_age_meta;
          this.insightsData = res.data?.data?.insight_data;
          this.insightsHeader = res.data?.data?.insight_graph_header;
          // this.categoryWiseTableData = res.data?.data?.ad_type_data;
          this.isViewCampaignDataLoader = false;
          this.maxSales = res.data?.data?.rounded_max_sales;
          this.$nextTick(() => {
            this.processGaraphData(res.data?.data);
            this.processTable("#campaignTable-tbl", 4);
            this.processTable("#insights-table", 1);
            // this.processTable("#category-table", 1);
          });
          this.loader12 = false;
          this.campLoader = false;
          this.isInsightDataLoader = false;
        })
        .catch((err) => {
          console.log("err", err);
          this.campLoader = false;
          this.loader12 = false;
          this.isViewCampaignDataLoader = false;
          this.isInsightDataLoader = false;
        });
    },

    getInsightData() {
      const url =
        "/api/v2/slate/insights_oob?channel=" + this.selectedChannel.key;
      this.isAmazonInsight = true;

      this.$http
        .get(url)
        .then((res) => {
          this.amazonInsight = res.data?.data;
          this.isAmazonInsight = false;
        })
        .catch((err) => {
          console.error(err);
          this.isAmazonInsight = false;
          this.isAmazonInsight = false;
        });
    },

    getCampaginsInsight() {
      const url =
        "/api/v2/slate/insights_campaigns?channel=" + this.selectedChannel.key;
      this.isCampaignInsight = true;
      this.$http
        .get(url)
        .then((res) => {
          this.campaignInsight = res.data?.data;
          this.isCampaignInsight = false;
        })
        .catch((err) => {
          console.error(err);
          this.isCampaignInsight = false;
        });
    },

    filterBudgetUsage(sentiment) {
      let filteredSentimentData = [];

      switch (sentiment) {
        case "negative":
          filteredSentimentData = this.tableRawData?.filter(
            (row) =>
              row.flag?.value === "negative" || row.Campaign?.value == "Total"
          );
          $("#campaignTable-tbl").DataTable().destroy();
          this.viewCampaignData.data = filteredSentimentData;
          this.processTable("#campaignTable-tbl", 4);
          break;

        case "neutral":
          filteredSentimentData = this.tableRawData?.filter(
            (row) =>
              row.flag?.value === "negative" || row.Campaign?.value == "Total"
          );
          $("#campaignTable-tbl").DataTable().destroy();
          this.viewCampaignData.data = filteredSentimentData;
          this.processTable("#campaignTable-tbl", 4);
          break;

        case "all":
          $("#campaignTable-tbl").DataTable().destroy();
          this.viewCampaignData.data = this.tableRawData;
          this.processTable("#campaignTable-tbl", 4);
          break;
      }
    },
    processGaraphData(data) {
      this.campaignGraphData = {};
      this.campaignGraphData = {
        xAxisName: "Sales",
        yAxisName: "ACOS",
        zAxisName: "Spends",
        targetACOS: data.min_max.ACOS.target_acos,
        avgACOS: data.min_max.ACOS.mean,

        ACOSMaxValue: "",
        xAxis: {
          min: data.min_max[this.selectedScatterChart].min,
          max: data.min_max[this.selectedScatterChart].max,
          mean: data.min_max[this.selectedScatterChart].mean,
        },
        yAxis: {
          min: data.min_max.ACOS.min,
          max: data.min_max.ACOS.max,
          mean: data.min_max.ACOS.target_acos,
        },
        zAxis: {
          min: data.min_max.Spends.min,
          max: data.min_max.Spends.max,
          mean: data.min_max.Spends.mean,
        },
        seriesData: [
          {
            name: "ACOS VS " + this.selectedScatterChart,
            data: [],
            colorByPoint: true,
          },
        ],
      };

      let i = 0;
      let j = 0;
      let k = 0;
      let l = 0;
      for (let row of data?.graph_data) {
        if (row?.campaign_age?.value === "New") {
          this.campaignGraphData?.seriesData[0]?.data.push({
            name: row["Campaign Name"].value,
            x: row[this.selectedScatterChart]?.value,
            y: row.ACOS["value"],
            z: row.Spends["value"],
            color: "#1ACF85",
          });
          i++;
        }
        if (row.campaign_age.value === "Old") {
          this.campaignGraphData?.seriesData[0]?.data.push({
            name: row["Campaign Name"].value,
            x: row[this.selectedScatterChart]?.value,
            y: row.ACOS["value"],
            z: row.Spends["value"],
            color: "#00A1C9",
          });
          j++;
        }
        if (row.campaign_age.value === "Intermediate") {
          this.campaignGraphData?.seriesData[0]?.data.push({
            name: row["Campaign Name"].value,
            x: row[this.selectedScatterChart]?.value,
            y: row.ACOS["value"],
            z: row.Spends["value"],
            color: "#FFAB00",
          });
          k++;
        }
        if (row.campaign_age.value === "NA") {
          this.campaignGraphData?.seriesData[0]?.data.push({
            name: row["Campaign Name"].value,
            x: row[this.selectedScatterChart]?.value,
            y: row.ACOS["value"],
            z: row.Spends["value"],
            color: "#667BFE",
          });
          l++;
        }
      }
    },

    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    removeRules(idx) {
      this.rules.splice(idx, 1);
    },
    multipleEmail(campIndex) {
      if (!this.validEmail(this.tempEmail)) {
        this.emailError = true;
        return false;
      }
      this.emailError = false;
      // this.camp_rules[campIndex].email.push(this.tempEmail);
      this.tempEmail = "";
    },
    decodeHTML(html) {
      txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },

    processTable(id, sortCol = 0) {
      $(id).DataTable().destroy();
      $(id).DataTable({
        searching: true,
        info: true,
        sorting: [[sortCol, "desc"]],
        // scrollY: scrollVertical || false,
        initComplete: function (settings, json) {
          $(id).wrap(
            "<div style='overflow:auto; width:100%;position:relative;'></div>"
          );
        },
        language: {
          search: "",
          searchPlaceholder: "Search...",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
      });

      $(id + "_filter > label").append(`
        <div class='search_icon'>
            <img src='/Icons_SVG/Search.svg' width='20' />
        </div>
        `);
    },
    changeDateRange() {
      this.formatDateRange();
      this.movingAverageData();
    },
    handleIsFilter() {
      const existingValue = this.storeNumericFilterValue?.find(
        (item) => item[0]?.field === this.selectedNumericCampaignValue
      );

      if (existingValue) {
        this.selectedNumericMatricsValue = existingValue[0]?.operation;
        this.matricsInputValue = existingValue[0]?.value;
      }
      this.matricsInputValue = "";
      this.StringMatricsInputValue = "";
      this.isFilter = true;
    },
    clearFilter() {
      this.isFilter = false;
      this.matricsInputValue = "";
      this.StringMatricsInputValue = "";
    },
    handleFilterModal(
      data,
      storeFilterValue,
      selectedMatricsValueKey,
      matricsInputValueKey
    ) {
      if (data?.length <= 0) {
        return false;
      }

      let existingValue = storeFilterValue?.find(
        (item) =>
          item[0]?.field === data &&
          item[0]?.operation === this[selectedMatricsValueKey]
      );

      if (existingValue) {
        this[matricsInputValueKey] = existingValue[0]?.value;
      } else {
        this[matricsInputValueKey] = "";
      }
    },
    handleNumericFilterModal(data) {
      this.handleFilterModal(
        data,
        this.storeNumericFilterValue,
        "selectedNumericMatricsValue",
        "matricsInputValue"
      );
    },
    handleStringFilterModal(data) {
      this.handleFilterModal(
        data,
        this.storeStringFilterValue,
        "selectedStringMatricsValue",
        "StringMatricsInputValue"
      );
    },
    handleNumericMatricFilterModal(data) {
      let existingValue = this.storeNumericFilterValue?.find(
        (item) =>
          item[0]?.field === this.selectedNumericCampaignValue &&
          item[0]?.operation === data
      );
      if (existingValue) {
        this.matricsInputValue = existingValue[0]?.value;
      } else {
        this.matricsInputValue = "";
      }
    },
    handleStringMatricsFilterModal(data) {
      let existingValue = this.storeStringFilterValue?.find(
        (item) =>
          item[0]?.field === this.selectedStringCampaignValue &&
          item[0]?.operation === data
      );
      if (existingValue) {
        this.StringMatricsInputValue = existingValue[0]?.value;
      } else {
        this.StringMatricsInputValue = "";
      }
    },
    handlePostFilters({
      selectedCampaignValue,
      selectedMatricsValue,
      matricsInputValue,
      storeFilterValue,
    }) {
      if (!matricsInputValue) {
        return false;
      }
      let existingFilter = storeFilterValue?.find(
        (item) =>
          item[0]?.field === selectedCampaignValue &&
          item[0]?.operation === selectedMatricsValue
      );

      if (existingFilter) {
        existingFilter[0].value = isNaN(matricsInputValue)
          ? matricsInputValue
          : parseFloat(matricsInputValue);
      } else {
        storeFilterValue.push([
          {
            operation: selectedMatricsValue,
            field: selectedCampaignValue,
            value: isNaN(matricsInputValue)
              ? matricsInputValue
              : parseFloat(matricsInputValue),
          },
        ]);
      }
    },
    postNumericalFilters() {
      this.handlePostFilters({
        selectedCampaignValue: this.selectedNumericCampaignValue,
        selectedMatricsValue: this.selectedNumericMatricsValue,
        matricsInputValue: this.matricsInputValue,
        storeFilterValue: this.storeNumericFilterValue,
      });
      this.isFilter = false;
    },
    handlePostStringFilters() {
      if (!this.StringMatricsInputValue) {
        return false;
      }
      this.storeStringFilterValue.push([
        {
          operation: this.selectedStringMatricsValue,
          field: this.selectedStringCampaignValue,
          value: this.StringMatricsInputValue,
        },
      ]);
      this.isFilter = false;
    },
    handlePostCampaignAgeFilters() {
      const existValue = this.storeCampaignAge?.find((item) =>
        item?.some(
          (campaignAge) => campaignAge.value === this.selectedCampaignAgeValue
        )
      );
      if (existValue) {
        return false;
      }
      this.storeCampaignAge.push([
        {
          operation: "",
          field: this.selectedCampaignAgeMetricValue,
          value: this.selectedCampaignAgeValue,
        },
      ]);
      this.isFilter = false;
    },
    removeFilterValue(storeFilterValue, data) {
      const index = storeFilterValue
        .flat()
        .findIndex(
          (item) =>
            item?.field === data?.field &&
            item?.operation === data?.operation &&
            item?.value === data?.value
        );

      if (index !== -1) {
        storeFilterValue.splice(index, 1);
      }
    },
    RemoveFilterBadgeValue(data) {
      this.removeFilterValue(this.storeNumericFilterValue, data);
      this.removeFilterValue(this.storeCampaignAge, data);

      for (let i = 0; i < this.storeStringFilterValue?.length; i++) {
        const itemArray = this.storeStringFilterValue[i];
        const matchIndex = itemArray.findIndex(
          (item) =>
            item?.field === data?.field &&
            item?.operation === data?.operation &&
            item?.value === data?.value
        );

        if (matchIndex !== -1) {
          this.storeStringFilterValue.splice(i, 1);
          break;
        }
      }
    },
    RemoveAllFilterBadgeValue() {
      this.storeNumericFilterValue = [];
      this.storeStringFilterValue = [];
      this.storeCampaignAge = [];
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.customMultiselectCommon .multiselect__placeholder {
  margin-bottom: 6px !important;
  padding: 0px !important;
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.customMultiselectCommon span.multiselect__single {
  display: flex;
  align-items: center;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.customMultiselectCommon .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  max-height: 36px !important;
  font-family: "poppins";
  overflow-y: auto !important;
}

.customMultiselectCommon .multiselect__tags .multiselect__single {
  font-size: 14px !important;
}

.customMultiselectCommon .multiselect__select {
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__select::before {
  top: 56% !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__tag {
  background: var(--primary_brand-80) !important;
  margin-bottom: 0px !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__tag-icon:after {
  color: #fff !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__content-wrapper {
  border: 1px solid var(--base_color-40) !important;
  border-top: none !important;
  font-family: "poppins";
}

.customMultiselectCommon
  .multiselect__option--selected.multiselect__option--highlight {
  background: var(--red) !important;
  color: var(--white) !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__option--highlight {
  background: var(--base_color-20) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__element {
  color: var(--primary_brand-80) !important;
  border-bottom: 1px solid var(--base_color-20);
  font-family: "poppins";
  font-size: 14px !important;
}

/* width */
.customMultiselectCommon ::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
  display: none;
}

/* Track */
.customMultiselectCommon ::-webkit-scrollbar-track {
  background: var(--base_color-20);
  border-radius: 10px;
}

/* Handle */
.customMultiselectCommon ::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
.customMultiselectCommon ::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

.customMultiselectCommon .multiselect__input:focus {
  border: none !important;
  color: #000 !important;
  box-shadow: none;
}
</style>

<style scoped>
button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}
.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}
.amsTooltip {
  position: relative;
  display: inline-block;
}

.amsTooltiptext {
  visibility: hidden;
  width: 220px;
  background-color: #ffffff;
  color: #000;
  text-align: center;
  border-radius: 6px;
  padding: 7px 5px;
  position: absolute;
  z-index: 7777 !important;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;
  opacity: 0;
  font-size: 12px;
  transition: opacity 0.3s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.amsTooltip:hover .amsTooltiptext {
  visibility: visible;
  opacity: 1;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
  padding: 1rem !important;
}

#customFilterDropdown select:focus {
  border-color: #b3b2b9 !important;
  box-shadow: none !important;
}

#customFilterDropdown select {
  border-color: #b3b2b9 !important;
  background: white !important;
  height: 35px !important;
}

@media (max-width: 1280px) {
  #customFilterDropdown select {
    height: 35px;
    padding-top: 1px;
    font-size: 13px;
  }

  #customFilterDropdown input {
    height: 35px;
  }
}

.inSightsContainer {
  border-radius: 5px !important;
  border: 1px solid #d9d9d9;
}

.inSightsContainer > div:first-child {
  border-right: 1px solid #d9d9d9;
}

.thin-scrollerBar::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 6px;
  background: #ebedee;
}

.thin-scrollerBar::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}

.thin-scrollerBar::-webkit-scrollbar-thumb {
  border-radius: 6px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: #b3b2b9;
}

.thin-scrollerBar::-webkit-scrollbar-thumb:hover {
  background: #8b8d94;
  cursor: pointer;
}

.toggle-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-family: sans-serif;
}
</style>
